import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IPatientWaitingStatsParamsBody, IPatientWaitingStatsResponse } from "@/api_framework/api_modals/Patients";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setPatientWaitingStats } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const usePatientWaitingStatsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (filterParams: IPatientWaitingStatsParamsBody) => {
      dispatch(
        setLoading({
          key: "isPWLStatsFetchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(PATIENT_WAITING_LIST?.PATIENT_STATS?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPatientWaitingStatsResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setPatientWaitingStats({
                  data: res.data.data,
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLStatsFetchInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setPatientWaitingStats({
                  data: [],
                }),
              );
              dispatch(
                setLoading({
                  key: "isPWLStatsFetchInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isPWLStatsFetchInProgress",
                status: false,
              }),
            );
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              // toast.error("Error while fetching stats list");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
